import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DesignPartnerDomainsService {
  private apiUrl = `${environment.BACKEND_URL}/design-partner`;
  private certKitUrl = 'https://ct.certkit.io/search';

  constructor(private http: HttpClient) {}

  getDomains(): Observable<any> {
    return this.http.get(`${this.apiUrl}/domains`);
  }

  addDomain(domain: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/domains`, { domain });
  }

  searchCertificates(domain: string): Observable<any> {
    return this.http.post(this.certKitUrl, { domain, sort: '' });
  }

  saveSubDomains(domain: string, records: any[]): Observable<any> {
    return this.http.post(`${this.apiUrl}/sub-domains`, { domain, records });
  }

  getSubDomains(domain: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/sub-domains`, { params: { domain } });
  }

  getTlsInfo(subdomain: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/tls`, { params: { domain: subdomain } });
  }
}
